import React, { useState, useEffect, Fragment } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';
import { Icon } from 'react-icons-kit';
// import 'react-image-gallery/styles/css/image-gallery.css';
import { mediaRecordOutline } from 'react-icons-kit/typicons/mediaRecordOutline';
import { plus } from 'react-icons-kit/typicons/plus';
import { starOutline } from 'react-icons-kit/typicons/starOutline';
import Text from 'reusecore/src/elements/Text';
import Image from 'reusecore/src/elements/Image';
import Heading from 'reusecore/src/elements/Heading';
import Tab, { Panel } from 'common/src/components/Tabs';
import Container from 'common/src/components/UI/Container';
import FeatureBlock from 'common/src/components/FeatureBlock';
import { SectionHeader } from '../AppClassic/appClassic.style';
import SectionWrapper, { TabArea } from './style';
import ImageGallery from 'react-image-gallery';
import FeatureSliderWrapper from './sliderWithImage.style';
import Box from 'reusecore/src/elements/Box';
function getSize() {
  return {
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    outerHeight: window.outerHeight,
    outerWidth: window.outerWidth,
  };
}

function useWindowSize() {
  let [windowSize, setWindowSize] = useState(getSize());

  function handleResize() {
    setWindowSize(getSize());
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowSize;
}



const FeatureTab = () => {
  const data = useStaticQuery(graphql`
    query {
      featuresJson {
        section3 {
          slogan
          title
          tab {
            color
            icon {
              publicURL
            }
            title
            details
            image {
              publicURL
            }
            thumbnail {
              publicURL
            }
            original {
              publicURL
            }
          }
        }
      }
    }
  `);
  console.log("---> data.tab", data);

  const mapped = data.featuresJson.section3.tab.map((i) => {
    return Object.assign({}, i, {
      original: i.original.publicURL
    });
  });

  console.log("---> ", mapped);

  const { slogan, title, tab } = data.featuresJson.section3;
  const size = process.browser && useWindowSize();
  const innerWidth = process.browser && size.innerWidth;
  const sliderRef = React.createRef();

  return (
    <SectionWrapper>
      <Container>
        <SectionHeader>
          <Fade up>
            <Heading as="h5" content={slogan} />
            <Heading content={title} />
          </Fade>
        </SectionHeader>
        <Fade up delay={100}>
          <TabArea>
            <Tab active={0} callback={(index) => {
              console.log("---> index: ", index);
              sliderRef.current.slideToIndex(index);
            }}>
              {tab.map(item => (
                <Panel
                  title={
                    <FeatureBlock
                      style={{ '--color': `${item.color}` }}
                      iconPosition="left"
                      icon={
                        <Fragment>
                          <Icon className="plus" icon={plus} />
                          <Icon className="circle" icon={mediaRecordOutline} />
                          <Image src={item.icon.publicURL} alt={item.title} />
                          <Icon className="star" icon={starOutline} />
                        </Fragment>
                      }
                      title={<Heading as="h3" content={item.title} />}
                      description={<Text content={item.details} />}
                    />
                  }
                  key={`app-tab--key${item.id}`}
                >
                  {
                    innerWidth > 1220 &&
                    <FeatureSliderWrapper>
                      <Box className='FeatureSlider'>
                        <ImageGallery
                          items={mapped}
                          className="Slider-img"
                          showPlayButton={false}
                          showFullscreenButton={false}
                          showNav={false}
                          showBullets={false}
                          renderThumbInner={() => <span></span>}
                          ref={sliderRef}
                        // autoPlay={true}
                        />
                      </Box>
                    </FeatureSliderWrapper>
                  }
                  {/* <Slide left>
                    <Image src={item.image.publicURL} alt={item.title} />
                  </Slide> */}
                </Panel>
              ))}
            </Tab>
          </TabArea>
        </Fade>
      </Container>

    </SectionWrapper >
  );
};

export default FeatureTab;
